<template>
    <div id="editProductMultiple">
      <CCard class="shadow-sm" style="">
        <CCardBody>
          <CRow>
            <CIcon size="2xl" name="cil-basket" class="text-success col-2 col-sm-1 col-lg-1" />
            <CCol col="7" sm="9" md="9" lg="9">
              <select class="custom-select text-dark" v-model="shopObjectId" disabled id="shop-select">
                <option selected>{{ $t('selectshop') }}</option>
                <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                  {{ shop.shopName }} - {{ shop.branchName }}
                </option>
              </select>
            </CCol>
            <div class="col-3 col-sm-2 col-md-2 text-right">
              <CButton block color="light" @click="goback" class="align-items-center" id="back-button">
                <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{ $t('back') }}
              </CButton>
            </div>
          </CRow>
        </CCardBody>
      </CCard>
      <div v-if="isPermission">
        <CCard class="shadow-sm" >
          <CCardBody  style="padding: 1.55rem">
            <div class="row mb-1">
              <div class="col-md-10 col-sm-9 col-8 d-inline-flex align-items-center">
                <h2 class="font-weight-normal" >
                  {{ $t("ditProductByCategoryTitle") }} <img  src="/img/grabFood.svg" width="120px;" >
                </h2>
              </div>
            </div>
            <CAlert  color="info" class="d-inline-block col-12 mt-1 mb-2">
              <div class="d-flex p-1">
                  <div class="flex-shrink-0">
                      <i class="fi fi-rr-info mr-1 text-warning"></i>
                  </div>
                  <div class="flex-grow-1 ms-3 ml-2">
                      <!-- <p class="m-0">{{ $t('ditProductByCategoryTitle') }}</p>    -->
                      <p v-html="$t('ditProductByCategoryDes')" class="text-description text-muted mb-0"></p>   
                  </div>
              </div>
          </CAlert>
          <CAlert color="warning" class="d-flex align-items-center" :show.sync="syncValidateCounter" closeButton>
            <CIcon name="cil-warning" class="flex-shrink-0 me-2" width="16" height="16" />
            <div class="ml-2">
              {{desAlertText}}
            </div>
          </CAlert>
            <CRow class="justify-content-between">
              <CCol>
                <h5  class="font-weight-normal col-form-label h5">
                  {{ $t("product") }} {{ countProduct }} {{ $t("item") }}
                </h5>
              </CCol>
              <CCol class="col-2">
                <div class="btn-group btn-group-toggle row view-list mr-1" data-toggle="buttons">
                  <CButton v-if="updateList.length > 0 && isEditData"  color="warning"
                    @click="confirmSaveProductMultipleModal = true">{{ $t("save") }} ({{ updateList.length }}
                    {{ $t("item") }})</CButton>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="3" lg="3" xl="1">
                <div class="sort mb-2 pt-1 pr-1 pl-1"  style="height: 49px;">
                    <select v-model.number="meta_data.limit" class="text-dark form-control "  >
                        <option :value="10">10</option>
                        <option :value="15">15</option>
                        <option :value="20">20</option>
                        <option :value="25">25</option>
                        <option :value="30">30</option>
                        <option :value="35">35</option>
                        <option :value="40">40</option>
                        <option :value="45">45</option>
                        <option :value="50">50</option>
                    </select>
                </div>
              </CCol>
              <CCol sm="12" md="9" lg="9" xl="11">
                <sortdata  v-on:getSort="setSort" :sort_value="sort_value"
                  :sortdata="sortdata" class="mb-3" />
              </CCol>
              <CCol sm="12" md="12" lg="12" xl="12">
                <div class="sort mb-3 pt-1 pr-1 pl-1"  style="text-align: center;">
                    <CRow class="mb-1">
                        <CCol lg="3" md="3" sm="3" col="12">
                            <multiselect  v-model="searchCategory" :options="dataCategory"
                                :search="true" :showLabels="false" :close-on-select="true" :clear-on-select="false"
                                :placeholder="$t('category')" label="name" track-by="name" @input="setSearch"
                                class="text-dark font-weight-normal  align-items-center" 
                                style=" margin-top: 3px;
                                        -webkit-box-align: center !important;
                                        -ms-flex-align: center !important;
                                        align-items: center !important;" >
                            </multiselect>
                        </CCol>
                        <CCol lg="5" md="5" sm="5" col="12">
                            <CRow>
                                <CCol lg="12">
                                    <div class="input-group percentage-input " style="padding-top: 2px;" >
                                        <!-- Select เพิ่ม/ลด -->
                                        <select v-model="priceMode" class="text-dark custom-select-mode"  >
                                            <option value="increase">{{$t('overPrice')}}</option>
                                            <option value="decrease">{{$t('underPrice')}}</option>
                                        </select>

                                        <!-- ช่องกรอกเปอร์เซ็นต์ -->
                                        <div class="input-group-append " >
                                            <span class="input-group-text input-green-border"   
                                                  style="border-left: 1px solid #d8dbe0; border-top-left-radius: 4px; border-bottom-left-radius: 4px;color: #29b289;" >
                                              ~
                                            </span>
                                        </div>
                                        <input
                                            aria-label="%"
                                            type="number"
                                            min="0"
                                            max="100"
                                            class="form-control text-dark input-green-border"
                                            v-model="percent"
                                            placeholder="%"
                                        />

                                        <!-- ไอคอน % -->
                                        <div class="input-group-append">
                                            <span class="input-group-text input-green-border" style="color: #29b289;" >
                                            %
                                            </span>
                                        </div>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol lg="2" md="2" sm="2" col="6">
                          <select v-model="roundingMode" class="text-dark form-control" style=" margin-top: 2px;">
                            <option value="default">{{$t('defaultRound')}}</option>
                            <option value="nearest0">{{ $t('nearest0') }}</option>
                            <option value="nearest5">{{ $t('nearest5') }}</option>
                          </select>
                        </CCol>
                        <CCol lg="2" md="2" sm="2" col="6">
                            <CButton color="success" block style="margin-top: 2px;" @click="adjustAllPrices" ref="adjustBtn">
                                {{ $t('adjustPrice') }}
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
              </CCol>
            </CRow>
            <CRow class="mb-2">
              <CCol sm="12" lg="12">
                <div  class="mb-3" style="overflow-x: auto">
                  <DataTable :items="items" :fields="fields"  hover  sticky-header
                    style="white-space: nowrap">
                    <template #head(select)>
                        <div class="text-center mt-1">
                            <div class="custom-checkbox-wrapper">
                            <input
                                type="checkbox"
                                id="selectAll"
                                :checked="areAllSelected"
                                @change="toggleSelectAll"
                                class="custom-checkbox-input"
                            />
                            <label for="selectAll" class="ml-2 mb-0">{{$t('allProduct')}}</label>
                            </div>
                        </div>
                    </template>
                    <template #SKUName="{ item }">
                      <td>
                        <CRow style="width: 300px" class="">
                            <CCol class="col-lg-3">
                                <div
                                    class="display text-center"
                                    style="width: 60px"
                                    >
                                    <img
                                        v-if="item.ProductSKU.remoteImagePath"
                                        :src="item.ProductSKU.remoteImagePath"
                                        class="img-fluid rd"
                                        style="border-radius: 3px"
                                        @error="noImgUrl"
                                    />
                                    <div
                                        v-else
                                        class="image-placeholder"
                                        :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.ProductSKU.indexColor), 'border-radius': '3px' }"
                                    ></div>
                                    </div>
                            </CCol>
                            <CCol class="col-lg-9" style="align-content: center;">
                                <p class="text-dark mb-0"> {{item.ProductSKU.SKUName}}</p>
                            </CCol>
                        </CRow>
                      </td>
                    </template>
                    <template #select="{ item }">
                        <td class="text-left ">
                            <div class="custom-checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    :id="'checkbox-' + item.ProductSKU.objectId"
                                    :value="item.ProductSKU.objectId"
                                    v-model="selectedItems"
                                    class="custom-checkbox-input"
                                />
                                <label :for="'checkbox-' + item.ProductSKU.objectId"></label>
                            </div>
                        </td>
                    </template>
                    <template #img="{ item, index }">
                      <td class="text-center" style="width: 60px">
                        <CRow>
                        <div
                          class="display text-center"
                          style="width: 60px"
                        >
                          <img
                            v-if="item.remoteImagePath"
                            :src="item.remoteImagePath"
                            class="img-fluid rd"
                            @click="getModalImg(item, index)"
                            style="border-radius: 3px"
                            @error="noImgUrl"
                          />
                          <div
                            v-else
                            @click="getModalImg(item, index)"
                            class="image-placeholder"
                            :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.indexColor), 'border-radius': '3px' }"
                          ></div>
                        </div>
                        </CRow>
                      </td>
                    </template>    
                    <template #category="{ item }">
                      <td>
                        <p class="text-dark mb-0">{{ item.ProductSKU.category?.name || '-' }}</p>
                      </td>
                    </template>
                    <template #unit="{ item, index }">
                      <td>
                        <!-- <p class="text-dark mb-0"> {{item.ProductPLU.unit.name }}</p> -->
                      </td>
                    </template>
                    <template #grabPrice="{ item, index }">
                      <td class="text-right">
                        <input :id="'priceInput_' + index" v-model.number="item.grabPrice" min="0" type="number"
                          class="form-control" @input="updateItem(index, 'grabPrice', item.grabPrice)"
                          style="width: 220px" disabled />
                      </td>
                    </template>
                    <template #SKUPrice="{ item, index }">
                      <td class="text-right">
                        <input :id="'priceInput_' + index" v-model.number="item.newPrice" min="0" type="number"
                          class="form-control input-green-border" @input="updateItem(index, 'newPrice', item.newPrice)"
                          style="width: 220px" />
                      </td>
                    </template>
                    <template #differentPrice="{ item}">
                        <td>
                            <p :class="getPriceClass(item.grabPrice, item.newPrice)" class="mb-0">
                            {{ calculateDifference(item.grabPrice, item.newPrice).toFixed(2) }}
                            </p>
                        </td>
                    </template>
                   
                  </DataTable>
                </div>
              </CCol>
            </CRow>
            <pagination  :meta_data="meta_data" v-on:next="handlePageChange">
            </pagination>
          </CCardBody>
        </CCard>
        <CRow>
          <CModal id="deleteModal" color="danger" :show.sync="deleteModal" centered>
            <h4 class="text-center">{{ $t("dialigDeleteProduct") }}</h4>
            <br />
            <h5 class="text-center">{{ $t("confirmDeleteProduct") }}</h5>
            <template #footer>
              <div class="mx-auto">
                <CCol col="12">
                  <CButton id="confirmDeleteButton" color="danger" @click="deleteUnit(itemDelete)">
                    {{ $t("submit") }}
                  </CButton>
                </CCol>
              </div>
              <div class="mx-auto">
                <CButton id="cancelDeleteButton" color="light" @click="deleteModal = false">
                  {{ $t("cancel") }}
                </CButton>
              </div>
            </template>
          </CModal>
        </CRow>
        <CModal :show.sync="confirmSaveProductMultipleModal"  size="xl"
          :title="$t('confirmSaveImg')" centered>
          <CCard class="m-0 pb-0">
            <CCardBody class="pt-0 pb-0">
              <div>
                <p>{{ $t("product") }} {{ updateList.length }} {{ $t("item") }}</p>
                <div style="">
                <div  class="table-scroll-wrapper" >
                <DataTable :items="updateList" :fields="fieldsUpdateList"  hover  sticky-header
                    style="white-space: nowrap">
                    <template #SKUName="{ item }">
                      <td>
                        <CRow style="width: 300px">
                          <CCol class="col-lg-3">
                            <div class="display text-center" style="width: 60px">
                              <img
                                v-if="item.ProductSKU.remoteImagePath"
                                :src="item.ProductSKU.remoteImagePath"
                                class="img-fluid rd"
                                style="border-radius: 3px"
                                @error="noImgUrl"
                              />
                              <div
                                v-else
                                class="image-placeholder"
                                :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.ProductSKU.indexColor), 'border-radius': '3px' }"
                              ></div>
                            </div>
                          </CCol>
                          <CCol class="col-lg-9">
                            <p class="text-dark mb-0">{{ item.ProductSKU.SKUName }}</p>
                          </CCol>
                        </CRow>
                      </td>
                    </template>

                    <template #grabPrice="{ item }">
                      <td class="text-right">
                        <p class="text-dark mb-0">{{ item.grabPrice }}</p>
                      </td>
                    </template>

                    <template #SKUPrice="{ item }">
                      <td class="text-right">
                        <p class="text-dark mb-0">{{ item.newPrice }}</p>
                      </td>
                    </template>
                    <template #category="{ item }">
                      <td>
                        <p class="text-dark mb-0">{{ item.ProductSKU.category?.name || '-' }}</p>
                      </td>
                    </template>

                    <template #differentPrice="{ item }">
                      <td class="text-right">
                        <p :class="getPriceClass(item.grabPrice, item.newPrice)" class="mb-0">
                          {{ calculateDifference(item.grabPrice, item.newPrice).toFixed(2) }}
                        </p>
                      </td>
                    </template>
                    <template #action="{ item, index }">
                      <td class="text-center">
                        <img :id="'productBOMTableActionIcon' + index" src="/img/trash.png"
                          style="width: 14px; height: 14px; cursor: pointer" @click="conremoveRow(item, index)" />
                      </td>
                    </template>
                </DataTable>
                </div>
              </div>
              </div>
            </CCardBody>
          </CCard>
          <template #footer>
            <CRow class="col-12 justify-content-center">
              <CCol class="text-center" col="6">
                <CButton color="light" block @click="confirmSaveProductMultipleModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </CCol>
              <CCol class="text-center" col="6">
                <CButton v-if="loadingSaveProduct"  color="primary" block disabled>
                  <CSpinner  color="white" size="sm" />  {{ $t('save') }}
                </CButton>
                <CButton color="primary" block @click="saveEditProduct()" v-else >
                  {{ $t('save') }}
                </CButton>
              </CCol>
            </CRow>
          </template>
        </CModal>
      </div>
      <div id="noPermission" v-else>
        <access-data></access-data>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import util from "@/util/util";
  import pos from "@/services/local";
  import Pagination from "@/containers/Pagination";
  import Sortdata from "@/containers/SortData";
  import permis from "@/util/permission";
  import SearchPattern from "@/containers/SearchPattern";
  import Multiselect from "vue-multiselect";
  import DataTable from "@/containers/DataTable";
  import VueCropper from 'vue-cropperjs'
  import 'cropperjs/dist/cropper.css'
  import mime from '@/util/mime'
  
export default {
    components: {
        Pagination,
        Sortdata,
        SearchPattern,
        Multiselect,
        DataTable,
        VueCropper
    },
    data() {
        return {
            loadingSaveProduct: false,
            isEcommercePage: false,
            data: [],
            category: [],
            meta_data: {
                last_page: null,
                current_page: 1,
                prev_page_url: null,
                items: 0,
                limit: 10,
                itemCount: 0,
            },
            loadingButton: true,
            deleteModal: false,
            actionitem: false,
            sortdata: this.$route.query.sort || "SKUName",
            countProduct: 0,
            sort_value: {
                name: "SKUName",
                updated_at: "updated_at",
                sortByNumMin: "sortByNumMin",
                sortByNumMax: "sortByNumMax",
            },
            showView: this.isEcommercePage
                ? "list"
                : this.$route.query.view || "grid",
            view: "",
            keyword: this.$route.query.keyword || "",
            searchBy: this.$route.query.searchBy || "",
            updateList: [],
            confirmSaveProductMultipleModal: false,
            dataUnit: [],
            selectcolor: false,
            loadingSaveimg: true,
            indexColor: 1,
            selectedIndex: null,
            imageDataBtn: '',
            isUpload: true,
            itemObjectId: '',
            selectedRatio: 1, // ค่าเริ่มต้น 1:1
            cropperKey: 0,
            searchCategory: "",
            dataCategory: [],
            dragOverIndex: null,
            uploadingImageIndexes: [],
            dragUploadIndex: null,
            percent: 0,
            priceMode: "decrease",
            selectedItems: [],
            originalData:[],
            roundingMode: "default",
            syncValidateCounter : 0,
            desAlertText : ''
        };
    },
    computed: {
        ...mapGetters(["shops", "users", "date"]),
        areAllSelected() {
            return this.items.length > 0 && this.selectedItems.length === this.items.length;
        },
        cropperHeight() {
            if (window.innerWidth < 480) return 200;
            if (window.innerWidth < 768) return 250;
            return 300; // ค่าเริ่มต้นสำหรับหน้าจอใหญ่
        },
        colorList() {
            let data = []
            for (let i = 0; i < 30; i++) {
                data.push({
                    color: util.generateColor(i),
                    value: i,
                })
            }
            return data
        },
        cropRatios() {
            return [
                { label: "Freeform", value: "freeform" },
                { label: "1:1", value: "1:1" },
                { label: "3:2", value: "3:2" },
                { label: "4:3", value: "4:3" },
                { label: "16:9", value: "16:9" },
                { label: "Original Ratio", value: "original" }
            ]
        },
        isPermission() {
            return permis.findPermissionRead("product", '/product');
        },
        isEditData() {
            const value = permis.findPermissionEdit("product", '/product');
            return value; // && this.editItem
        },
        editItem() {
            let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
            return shop.editableItem || false;
        },
        shopObjectId: {
            get() {
                return this.$store.getters.shopObjectId;
            },
            set(newValue) {
                return this.$store.dispatch("setShop", newValue);
            },
        },
        uid() {
            let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
            return shop.uid;
        },
        sortAttr: {
            get() {
                let sortdata = this.sortdata;
                if (sortdata == "sortByNumMin" || sortdata == "sortByNumMax") {
                    sortdata = "ProductSKU.SKUPrice";
                }
                return sortdata;
            },
            set(newValue) {
                return newValue;
            },
        },
        itempage() {
            return this.meta_data.current_page * 50 - 50;
        },
        items() {
          return this.data.map((originalItem) => {
          // เช็คว่ามีการอัปเดตหรือไม่
            const updatedItem = this.updateList.find(
                (u) => u?.ProductSKU?.objectId === originalItem?.ProductSKU?.objectId
            );

            const item = updatedItem ? { ...updatedItem } : { ...originalItem };

            // ดึงข้อมูลเบื้องต้น
            const productSKU = item.ProductSKU || {};
            const productPLU = item.ProductPLU || {};
            const productPRU = item.ProductPRU || {};

            // ประมวลผลค่าต่าง ๆ
            const onhandQty = item.skuType === "SV" || item.skuType === "BOM"
                ? "non-stock products"
                : item.onhandQty ?? 0;

            const grabPRU = productPRU.find(pru => pru.PRUType?.id === "101");
            const storePRU = productPRU.find(pru => pru.PRUType?.id === "1");


            return {
                SKUName: item.SKUName || "-",
                unit: item.unit || {},
                onhandQty: util.convertNumber(onhandQty),
                SKUPrice: productPRU?.exceedUc ?? 0,
                productSKUObjectId: productSKU?.objectId,
                PLUCode: item.ProductSKU?.ProductPLU?.PLUCode || "-",
                ProductPLU: productPLU,
                category: this.findCategoryNameByObjectId(item?.ProductSKU?.category?.objectId),
                skuType: item.skuType,
                objectId: item.objectId,
                indexColor: item.indexColor,
                sortPrice: item.SKUPrice,
                created_at: item.created_at,
                isMenu: productPLU?.isMenu || false,
                edited: item.edited || false,
                ProductPRU: productPRU,
                grabPrice:grabPRU?.exceedUc || 0,
                storePRU : storePRU,
                grabPRU: grabPRU,
                ProductSKU: item.ProductSKU,
                newPrice: item.newPrice ? item.newPrice : 0,
            };
          });
        },
        queryparams() {
            return {
                sort: this.sortdata,
                page: this.meta_data.current_page,
                view: this.showView,
                searchBy: this.searchBy,
                keyword: this.keyword,
            };
        },
        filteredItems() {
            if (this.isEcommercePage) {
                return this.items.filter((item) => item.source === "SHOPEE");
            } else {
                return this.items;
            }
        },
        isDeleteData() {
            let path = "/product";
            return permis.findPermissionRemove("product", path);
        },
        categoryList() {
            let data = this.dataCategory;
            let detail = [];
            for (let i = 0; i < data.length; i++) {
                // if (data[i].enabled === true) {
                detail.push({
                    id: data[i].id,
                    name: data[i].name,
                    objectId: data[i].objectId,
                });
                // }
            }
            return detail;
        },
        fieldsUpdateList(){
            return [
            
                {
                    key: "SKUName",
                    label: this.$i18n.t("name"),
                    _classes: "text-left font-weight-normal text-dark font-weight-normal",
                    //    _style: 'width:5%;'
                },
            
                // {
                //     key: "SKUName",
                //     label: this.$i18n.t("name"),
                //     _classes: "text-left text-dark font-weight-normal",
                //     //    _style: 'width:30%'
                // },
                {
                    key: "category",
                    label: this.$i18n.t("category"),
                    _classes: "text-left text-dark font-weight-normal",
                },
                // {
                //     key: "unit",
                //     label: this.$i18n.t("unit"),
                //     _classes: "text-left text-dark font-weight-normal",
                // },
                {
                    key: "grabPrice",
                    label: this.$i18n.t("price"),
                    icon: '/img/delivery/grab.png',
                    _classes: "text-right text-dark font-weight-normal",
                    //    _style: 'width:15%'
                },
                {
                    key: "SKUPrice",
                    label: this.$i18n.t("percenPrice"),
                    _classes: "text-right text-dark font-weight-normal ",
                },
                {
                    key: "differentPrice",
                    label: this.$i18n.t("difference"),
                    _classes: "text-right text-dark font-weight-normal ",
                },
                {
                    key: "action",
                    label: this.$i18n.t(""),
                    _classes: "text-center font-weight-normal text-dark font-weight-normal",
                    //    _style: 'width:5%;'
                }
            ];
        },
        fields() {
            return [
                {
                    key: 'select',
                    label: '',
                    _classes: 'text-center',
                    sortable: false,
                     _style: 'width:100px;'
                },
                // {
                //     key: "img",
                //     label: this.$i18n.t(""),
                //     _classes: "text-center font-weight-normal text-dark font-weight-normal",
                //     //    _style: 'width:5%;'
                // },
                {
                    key: "SKUName",
                    label: this.$i18n.t("name"),
                    _classes: "text-left text-dark font-weight-normal",
                    //    _style: 'width:30%'
                },
                {
                    key: "category",
                    label: this.$i18n.t("category"),
                    _classes: "text-left text-dark font-weight-normal",
                },
                // {
                //     key: "unit",
                //     label: this.$i18n.t("unit"),
                //     _classes: "text-left text-dark font-weight-normal",
                // },
                {
                    key: "grabPrice",
                    label: this.$i18n.t("price"),
                    icon: '/img/delivery/grab.png',
                    _classes: "text-left text-dark font-weight-normal",
                    //    _style: 'width:15%'
                },
                {
                    key: "SKUPrice",
                    label: this.$i18n.t("priceCalculate"),
                    _classes: "text-left text-dark font-weight-normal ",
                },
                {
                    key: "differentPrice",
                    label: this.$i18n.t("difference"),
                    _classes: "text-left text-dark font-weight-normal ",

                }

            ];
        },
        unitlist() {
            let data = this.dataUnit;
            let detail = [];
            for (let i = 0; i < data.length; i++) {
                if (data[i].enabled === true) {
                    detail.push({
                        id: data[i].id,
                        name: data[i].name,
                        objectId: data[i].objectId,
                    });
                }
            }
            return detail.sort(util.compare);
        },
        page() {
            return this.$route.query.page || 1;
        },
        queryURL() {
            let searchBy = ''
            let keyword = ''

            if (this.searchCategory !== '') {
                searchBy = 'Category.objectId'
                keyword = this.searchCategory.objectId
            }
            return (
                "?sort=" +
                this.sortdata +
                "&page=" +
                this.page +
                "&view=" +
                this.showView +
                "&searchBy=" +
                searchBy +
                "&keyword=" +
                keyword
            );
        },
    },
    created() {
        this.getCategory()
        this.getProduct();
        this.getUnit();
        this.shop = this.shops.find((i) => this.shopObjectId === i.objectId);
    },
    watch: {
        percent(val) {
            if (val < 0) this.percent = 0
            else if (val > 100) this.percent = 100
        },
        'meta_data.limit'(newLimit, oldLimit) {
            // ตัวอย่าง: รีโหลดข้อมูลใหม่หลังจากเปลี่ยนจำนวนรายการต่อหน้า
            this.getProduct()
        }
    },
    mounted() {

    },
    methods: {
        ...util,
        roundPrice(price) {
          switch (this.roundingMode) {
            case 'nearest0':
              // ปัดเศษลงใกล้ 0 ที่หารด้วย 10 แล้วเศษน้อยที่สุด
              return Math.round(price / 10) * 10; // ถ้าอยากให้ปัดเข้าหา 0 จริง ๆ → return 0;
            case 'nearest5':
              return Math.round(price / 5) * 5;
            default:
              return Math.round(price);
          }
        },
        toggleSelectAll() {
            if (this.areAllSelected) {
            this.selectedItems = [];
            } else {
            this.selectedItems = this.items.map(item => item.ProductSKU.objectId);
            }
        },
        calculateDifference(grabPrice, skuPrice) {
            if (typeof grabPrice !== 'number' || typeof skuPrice !== 'number') return 0;
            return Math.round((skuPrice - grabPrice) * 100) / 100;
        },
        getPriceClass(grabPrice, skuPrice) {
            if (skuPrice < grabPrice) return 'text-danger';
            if (skuPrice > grabPrice) return 'text-success';
            return 'text-dark';
        },
        adjustAllPrices() {
          const percentValue = this.percent;

          if (isNaN(percentValue) || percentValue < 0 || percentValue > 100) {
            alert('กรุณากรอกเปอร์เซ็นต์ระหว่าง 0 ถึง 100');
            return;
          }

          let selected = this.data.filter(item =>
            this.selectedItems.includes(item.ProductSKU.objectId)
          );

          // เช็กจำนวนที่กำลังจะทำ
          const maxEditable = 50 - this.updateList.length;
          if (maxEditable <= 0) {
            this.desAlertText = this.$i18n.t('valedateSelectEdititem') 
            this.syncValidateCounter = 5
            return;
          }
          if (selected.length > maxEditable) {
            selected = selected.slice(0, maxEditable); // ตัดแค่ที่เหลือได้
            this.syncValidateCounter = 5
            this.desAlertText = this.$i18n.t('valedateSelectEdititem')
            console.log(`Only ${maxEditable} items can be adjusted to stay within the 50 limit.`);
          }

          selected.forEach((item) => {
            const productPRU = item.ProductPRU;
            const storeIndex = productPRU.findIndex(pru => pru.PRUType?.id === "101");
            const basePrice = item.ProductPRU[storeIndex]?.exceedUc || 0;

            let adjustedPrice = basePrice;

            if (this.priceMode === 'increase') {
              adjustedPrice = basePrice + (basePrice * (percentValue / 100));
            } else if (this.priceMode === 'decrease') {
              adjustedPrice = basePrice - (basePrice * (percentValue / 100));
            }

            const rounded = this.roundPrice(adjustedPrice);

            const dataIndex = this.data.findIndex(d =>
              d.ProductSKU.objectId === item.ProductSKU.objectId
            );
            if (dataIndex !== -1) {
              const productPRU = this.data[dataIndex].ProductPRU;
              const storeIndex = productPRU.findIndex(pru => pru.PRUType?.id === "1");

              if (storeIndex !== -1) {
                const updatedPRU = {
                  ...productPRU[storeIndex],
                  exceedUc: rounded
                };
                this.updateItem(dataIndex, 'newPrice', rounded);
              }
            }
          });

          this.$toast && this.$toast.success(`Adjusted prices for ${selected.length} items.`);
        },
        async handleDropImage(index, event) {
            event.preventDefault();
            event.stopPropagation();

            const files = event.dataTransfer.files;
            if (!files.length) return;

            const file = files[0];
            if (!file.type.startsWith("image/")) {
                alert("กรุณาเลือกเฉพาะไฟล์รูปภาพเท่านั้น");
                return;
            }

            const reader = new FileReader();
            reader.onload = async (e) => {
                this.dragUploadIndex = index; // แสดง spinner
                const base64 = e.target.result;

                try {
                    const resized = await this.resizeImage(base64);
                    const remoteImagePath = await this.onUploadProductImage(this.items[index].objectId, resized);
                    this.$set(this.data[index], 'remoteImagePath', remoteImagePath);

                    this.updateItem(index, "remoteImagePath", remoteImagePath);

                } catch (error) {
                    console.error("Upload failed:", error);
                } finally {
                    this.dragUploadIndex = null; // ซ่อน spinner
                }
            };
            reader.readAsDataURL(file);
        },
        handleDrop(event) {
            event.preventDefault();
            event.stopPropagation();
            const file = event.dataTransfer.files[0];

            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageDataBtn = e.target.result;
                    this.isUpload = false;
                    this.isload = true;
                    this.$nextTick(() => {
                        if (this.$refs.cropper) {
                            this.$refs.cropper.replace(this.imageDataBtn);
                        }
                    });
                };
                reader.readAsDataURL(file);
            } else {
                alert("กรุณาลากไฟล์รูปภาพเท่านั้น");
            }
            // หากต้องการให้ dragover มีเอฟเฟกต์สีขอบให้ใช้ @dragenter และ @dragleave เพื่อเพิ่ม / ลบคลาส dragover
        },
        findCategoryNameByObjectId(targetObjectId) {
            let categoryList = this.dataCategory;
            return categoryList.find(item => item.objectId === targetObjectId) || null
        },
        setCropRatio(value) {
            if (value === "freeform") {
                this.selectedRatio = NaN; // อัตราส่วนอิสระ
            } else if (value === "original") {
                const imageData = this.$refs.cropper.getImageData();
                this.selectedRatio = imageData.naturalWidth / imageData.naturalHeight; // คงอัตราส่วนเดิม
            } else {
                const [w, h] = value.split(":").map(Number); // แปลงค่า "3:2" -> [3, 2]
                this.selectedRatio = w / h;
            }
            this.cropperKey++;
        },
        setindexcolor(color) {
            if (this.selectedIndex !== null) {
                this.data[this.selectedIndex].indexColor = color; // อัปเดตค่า indexColor ใน items
                this.updateItem(this.selectedIndex, 'indexColor', color);
            }
            this.indexColor = color;
            this.selectcolor = false; // ปิด Modal หลังเลือกสี
        },
        getModalImg(item, index) {
            if (item.remoteImagePath && item.remoteImagePath !== '') {
                this.imageData = item.remoteImagePath;
                this.imageDataBtn = item.remoteImagePath;
                this.remoteImagePath = item.remoteImagePath;
                this.$refs.cropper = item.remoteImagePath;
                // ตรวจสอบว่า VueCropper โหลดหรือยัง ก่อนเรียก methods หรือ properties ใน ref
                this.$nextTick(() => {
                    if (this.$refs.cropper) {
                        this.$refs.cropper.replace(item.remoteImagePath); // อัปเดตรูปภาพที่จะแสดงใน cropper
                    }
                });
            } else {
                this.remoteImagePath = '';
                this.imageData = '';
                this.imageDataBtn = '';

            }
            this.itemObjectId = item.objectId;
            this.indexColor = item.indexColor;
            this.selectedIndex = index; // เก็บ index ของรายการที่เลือก
            this.selectcolor = true;
        },
        cancel() {
            if (this.remoteImagePath != undefined) {
                this.imageDataBtn = this.remoteImagePath
                this.selectcolor = false
                this.isUpload = true
                this.imageData = this.remoteImagePath
            }
            this.selectcolor = false
            this.isload = false
        },
        goback() {

            this.$router.push('/product' + this.queryURL)
        },
        getBGColor(i) {
            return util.generateColor(i)
        },
        saveEditProduct() {
            let data = this.updateList.map((item) => {
                return {
                    objectId: item.ProductSKU.objectId,
                    ProductPLU: {
                      id: item.storePRU.productPLU.id,
                      objectId: item.storePRU.productPLU.objectId,
                    },
                    ProductPRU: {
                        id: item.storePRU.id,
                        objectId: item.storePRU.objectId,
                        exceedUc: item.newPrice,
                    }
                };
            });

            let shopObjectId = this.shopObjectId;
            let headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) };
            this.loadingSaveProduct = true
            pos({
                method: "PATCH",
                url: "/api/v3.0/productsku/quick",
                data: data,
                headers: headers,
            })
                .then((res) => {

                    this.confirmSaveProductMultipleModal = false;
                    this.loadingSaveProduct = false
                    this.getProduct();
                    this.goback()
                    this.updateList = [];
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        conremoveRow: function (item, index) {
            var con = confirm('"' + item.SKUName + '" ' + this.$i18n.t("confirmDeleteProduct"));
            if (con == true) {
                this.updateList.splice(index, 1);
            }
        },
        getCategory() {
            const uid = `${localStorage.getItem("shopsUid")}`;
            const shopObjectId = this.shopObjectId;
            let params = {
                page: 1,
                limit: 1000,
            };
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            };
            pos
                .get("/api/v1.0/shop/" + uid + "/Category/data/" + shopObjectId, {
                    params, headers
                })
                .then((res) => {
                    this.dataCategory = res.data.data;
                    let data = this.dataCategory;
                    for (let i = 0; i < data.length; i++) {
                        // if (data[i].enabled === true) {
                        if (data[i].id == "0") {
                            this.category = {
                                id: data[i].id,
                                name: data[i].name,
                                objectId: data[i].objectId,
                            };
                            // }
                        }
                    }
                });
        },
        getUnit() {
            const uid = `${localStorage.getItem("shopsUid")}`;
            let params = { page: 1, limit: 1000 };
            const shopObjectId = this.shopObjectId;
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            };
            pos.get("/api/v1.0/uid/" + uid + "/Unit/data", { params, headers })
                .then((res) => {
                    this.dataUnit = res.data.data;
                });
        },
        deleteProduct() {
            const uid = `${localStorage.getItem("shopsUid")}`;
            const plan = this.users.currentPlan;
            const shopObjectId = this.shopObjectId;
            let data = {
                shopObjectId: shopObjectId,
                objectId: this.productSKUObjectId,
            };
            const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)};

            pos({
                method: "post",
                url: "/api/v1.0/" + uid + "/ProductSKU/softdelete",
                params: { plan: plan },
                data: data,
                headers: headers,
            })
                .then(
                    setTimeout(() => {
                        this.deleteModal = false;
                    }, 100)
                )
                .catch((error) => {
                    console.log(error);
                });
        },
        selectProduct() {
            this.$router.push("/ecommerce/SelectProduct");
        },
        checkStdCost(item) {
            return item.stdCost > item.sortPrice && item.sortPrice > 0;
        },
        toAddProduct() {
            this.$router.push("/product/newAddproduct");
        },
        toImportProduct() {
            this.$router.push("/product/importProduct");
        },
        noImgUrl(event) {
            event.target.src = process.env.VUE_APP_NOIMAGE;
        },
        getChange(value) {
            this.showView = value;
        },
        confirmdelete(item) {
            this.deleteModal = true;
            this.itemDelete = item;
        },
        reset() {
            this.keyword = "";
            this.getProduct();
        },
        productDetail(item) {
            let productSKUObjectId = item.productSKUObjectId;
            this.$store.dispatch("setProductID", productSKUObjectId);
            this.$store.dispatch("getProductSKUDatail");

            this.$router.push({
                name: "ProductDetail",
                params: { productSKUObjectId },
                query: {
                    sort: this.sortdata,
                    page: this.meta_data.current_page,
                    view: this.showView,
                },
            });
        },
        setSort(value) {
            this.sortdata = value;
            this.getProduct();
        },
        setSearch(searchBy, keyword) {
            this.keyword = keyword;
            this.searchBy = searchBy;
            this.getProduct();
        },
        getProduct(page = this.$route.query.page || 1) {
            this.searchLoadingButton = false;
            this.loadingButton = false;
            const uid = `${localStorage.getItem("shopsUid")}`;
            const shopObjectId = this.shopObjectId;
            const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)};

            let sortOrder = "";
            if (this.sortdata == "sortByNumMin") {
                sortOrder = "asc";
            } else if (
                this.sortdata == "sortByNumMax" ||
                this.sortdata == "updated_at"
            ) {
                sortOrder = "desc";
            } else {
                sortOrder = "asc";
            }

            let params = {
                shopObjectId: shopObjectId,
                page: page,
                sortAttr: this.sortAttr,
                sortOrder: sortOrder,
                limit: this.meta_data.limit,
                channel : '101'
            };
            // Add search attribute.      
            if (this.searchCategory !== null) {
                // params["searchVal"] = this.keyword;
                params["categoryObjectId"] = this.searchCategory.objectId
            }
            pos({
                url: "/api/v3.0/productsku/channel/price",
                params: params,
                headers: headers,
                method: "GET",
            }).then((res) => {
                this.data = res.data.data.map((item) => {
                  const storePRU = item.ProductPRU.find(pru => pru.PRUType?.id === "1");
                  return {
                    ...item,
                    edited: false,
                    newPrice: storePRU?.exceedUc || 0, // ค่าเริ่มต้นเป็น 0 ถ้าไม่เจอ
                  };
                });
                this.selectedItems =  this.data.map(item => item.ProductSKU.objectId);
                this.originalData = JSON.parse(JSON.stringify(this.data));

                if (res.data.paginate.items == undefined) {
                    this.countProduct = 0;
                    this.meta_data.items = 0;
                } else {
                    this.countProduct = res.data.paginate.items;
                    this.meta_data.items = res.data.paginate.items;
                }
                this.meta_data.last_page = res.data.paginate.pageCount;
                this.meta_data.current_page = res.data.paginate.currentPage;
                this.meta_data.itemCount = res.data.paginate.itemCount;
                this.meta_data.limit = res.data.paginate.perPage;
                // this.countlist = res.data.data.length;
                this.searchLoadingButton = true;
                this.loadingButton = true;
            });
        },
        async handlePageChange(newPage) {
            this.getProduct(newPage); // โหลดข้อมูลใหม่
        },
        updateItem(index, field, value) {
          const objectId = this.items[index].objectId;
          const originalItem = this.originalData.find(i => i.objectId === objectId);

          if (!originalItem) return;

          const originalValue = originalItem[field];
          const currentItem = { ...this.items[index], [field]: value };

          // ถ้ากลับไปเป็นค่าเดิม
          if (originalValue === value) {
            const idx = this.updateList.findIndex(i => i.objectId === objectId);
            if (idx !== -1) {
              this.updateList.splice(idx, 1);
            }
            this.items[index].edited = false;
            return;
          }

          // ถ้าเกิน 50 รายการแล้ว ไม่ให้เพิ่มใหม่
          const existingIndex = this.updateList.findIndex(i => i.objectId === objectId);
          if (existingIndex === -1 && this.updateList.length >= 50) {
            this.desAlertText = this.$i18n.t('valedateSelectEdititem')
            this.syncValidateCounter = 5
            return;
          }

          this.items[index][field] = value;
          this.items[index].edited = true;

          if (existingIndex !== -1) {
            this.updateList.splice(existingIndex, 1, currentItem);
          } else {
            this.updateList.push(currentItem);
          }
        },
        async resizeImage(base64Str, maxWidth = 650, maxHeight = 500) {
            return new Promise((resolve) => {
                let img = new Image()
                img.src = base64Str
                img.onload = () => {
                    let canvas = document.createElement('canvas')
                    const MAX_WIDTH = maxWidth
                    const MAX_HEIGHT = maxHeight
                    let width = img.width
                    let height = img.height

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width
                            width = MAX_WIDTH
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height
                            height = MAX_HEIGHT
                        }
                    }
                    canvas.width = width
                    canvas.height = height
                    let ctx = canvas.getContext('2d')
                    ctx.drawImage(img, 0, 0, width, height)
                    resolve(canvas.toDataURL())
                }
            })
        },
        async onUploadProductImage(ref, image) {
            let headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
            let data = { ref, image };
            try {
                const res = await pos({
                    method: 'POST',
                    url: '/api/v3.0/upload/productimage',
                    data,
                    headers,
                });
                return res.data.data.publicUrl;
            } catch (error) {
                console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
                return '';
            }
        },
    },
};
</script>
  <style>
  
  .icon-css {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 4px;
    padding-left: 0px;
  }
  
.percentage-input .form-control {
  border:1px solid #e8e8e8;
  border-right: none;
  border-radius: 5px 0 0 5px;
}

.percentage-input .input-group-text {
  background-color: transparent;
  border: 1px solid #e8e8e8;
  border-left: none;
  border-radius: 0 5px 5px 0;
  font-weight: bold;
}

.custom-percentage-group {
  display: flex;
  border: 2px solid orange;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  max-width: 350px;
  height: 38px;
}

/* select เพิ่ม/ลด */
.custom-select-mode {
  border: none;
  outline: none;
  background-color: white;
  color: #333;
  font-weight: bold;
  width: 120px;
  margin-right: 1rem;
  /* appearance: none; ซ่อนลูกศรบนบางเบราว์เซอร์ */
  display: block;

    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: transparent;
    background-color: white;
    border-color: #d8dbe0;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

/* input กรอก % */
.custom-percentage-input {
  border: none;
  outline: none;
  flex: 1;
  padding: 0 10px;
  color: #333;
}

/* ไอคอน % */
.custom-percent-icon {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-weight: bold;
}
@media screen and (max-width: 576px) {
  .custom-percentage-group {
    flex-direction: column;
    height: auto;
  }
  .custom-select-mode{
    margin-right: 0px;
  }

  .custom-select-mode,
  .custom-percentage-input,
  .custom-percent-icon {
    width: 100%;
    border-radius: 0 !important;
  }

  .custom-percent-icon {
    justify-content: flex-start;
    padding-left: 1rem;
  }
}
.custom-checkbox {
  accent-color: #29b289;
}

.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.custom-checkbox-input {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  background-color: #fff;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.custom-checkbox-input:checked {
  background-color: #29b289;
  border-color: #29b289;
}

.custom-checkbox-input:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.input-green-border {
  border: 1px solid #29b289 !important;
  box-shadow: none;
}

  </style>
  <style src="../../assets/styles/multiselect.css"></style>
  